import { render, staticRenderFns } from "./stock-goods.vue?vue&type=template&id=98b5a176&scoped=true"
import script from "./stock-goods.vue?vue&type=script&lang=js"
export * from "./stock-goods.vue?vue&type=script&lang=js"
import style0 from "./stock-goods.vue?vue&type=style&index=0&id=98b5a176&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b5a176",
  null
  
)

export default component.exports